<template>
  <section> 
    <b-row>
      <b-col>
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Autorizaciones Pendientes   
             </div>          
          </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :filterShow="false"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_autorizar"
                    dataRoute="usuarios"
                    @filtrar="getFiltrar"
                    >
                    <template v-slot:modal>
                      <sw-modalautorizar 
                        v-if="openModal.modal.modal==='Autorizar'"
                        @save="saveForm"                     
                        >
                      </sw-modalautorizar>                  
                      <sw-modalanularautorizar
                        v-if="openModal.modal.modal==='Anular'"
                        @save="saveForm"
                        >
                      </sw-modalanularautorizar>  
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row>   
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalanularautorizar from '@/components/modals/anularAutorizar.vue'
import SwModalautorizar from '@/components/modals/autorizar.vue'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalanularautorizar,
  SwModalautorizar
     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

